export type AdminRoleUser = {
    user_role_name?: string | null
} | null | undefined

export const isAdminUser = (user: AdminRoleUser): boolean =>
    user?.user_role_name === "Admin"
